import { useEffect as n } from "react";

function o(o, f, t) {
  n(function () {
    if (o) {
      var n = function n(_n) {
        t && t(o, _n);
      };

      return o.on(f, n), function () {
        o.off(f, n);
      };
    }
  }, [o]);
}

export { o as useEvent };